import { render, staticRenderFns } from "./PointsList.vue?vue&type=template&id=72c21478&scoped=true&"
import script from "./PointsList.vue?vue&type=script&lang=js&"
export * from "./PointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c21478",
  null
  
)

export default component.exports